// extracted by mini-css-extract-plugin
export default {"Container":"ppt_Container__iDeE9","backdrop":"ppt_backdrop__zD-H-"};